export default {
  values: {
    hiRes: 2000,
    lowRes: 1550,
  },
};
